module.exports = __webpack_public_path__ + "agoda-logo.png?dd424941cebd2a14136d534cfeb089c8";